import { getAllSpecializationAreasReq } from "../../../../../redux/guest-slices/common.slice"
import SpecializationAreas from "../../../../../components/ui/SpecializationAreas"
import InputField1 from "../../../../../components/ui/InputField1"
import FileInput from "../../../../../components/ui/FileInput"
import { Grid2 as Grid, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Fragment, useEffect, useState } from "react"


function LifeCoach({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b34"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="specializationCertificate"
          label="Coaching Certifications *"
          errText="Please upload coaching certifications"
          placeholderText="Upload Coaching Certifications"
          defaultValue={specialist?.profile?.specializationCertificate || []}
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Coaching Specialties *"
          errText="Please select coaching specialties"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="targetClientele"
          errText="Please enter target clientele"
          label="Target Clientele (e.g., Executives, Students) *"
          defaultValue={specialist?.profile?.targetClientele || ""}
          placeholder="Enter Target Clientele (e.g., Executives, Students)"
        />
      </Grid>

      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="additionalCertificates"
          label="Upload Additional certificates"
          placeholderText="Upload Section for Certifications"
          defaultValue={specialist?.profile?.additionalCertificates || []}
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >We welcome you to Innerpal's Life Coach Registration. Your role in guiding individuals to personal fulfillment is invaluable. Please fill in your professional details to start your journey with us.
      </Typography>
    </Fragment>
  )
}

export default LifeCoach